<template>
  <div class="strategy-table">

    <div 
      class="table-item"
      v-for="(item, index) in list" 
      :key="index">
      <div class="row-label">{{ item.label }}</div>
      <div class="row-content">{{ item.content }}</div>
    </div>

  </div>
</template>

<script>

export default {
  props: {
    list: Array,
  },
  data() {
    return {};
  },
  computed: {},
};

</script>

<style lang="less" scoped>
.strategy-table {
  color: #2F333D;
  background-color: #fff;
  border-radius: 2px;
  border: 1px solid #DEE2E6;
  .table-item {
    display: flex;
    align-items: stretch;
    border-top: 1px solid #E9EEF2;
    &:first-child {
      border-top: 1px solid transparent;
    }
    .row-label {
      width: 160px;
      font-size: 16px;
      line-height: 24px;
      padding: 16px;
      flex-shrink: 0;
      font-weight: 600;
      background: #FAFBFC;
      display: flex;
      align-items: center;
      word-break: break-all;
    }
    .row-content {
      flex: 1;
      padding: 16px;
      font-size: 14px;
      display: flex;
      line-height: 24px;
      word-break: break-all;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/country/country-visa-strategy/components/strategy-form-item/strategy-table.vue